import React from 'react';
import { AvatarSkeleton, DropdownButtonSkeleton } from '@odin-labs/components';
import { AuthUser, to } from 'acl';
import {
  ScheduleWorker,
  EditableShiftColumn,
  EditableShiftColumnName,
  ScheduleWorkerModalValue,
} from 'containers/jobsite/tabs/jobsiteSchedules/data/types';
import { ensureNonEmptyItems } from 'utils';
import { ScheduleWorkersTableActionsCell } from './ScheduleWorkersTableActionsCell';
import { ScheduleWorkersTableContractorCell } from './ScheduleWorkersTableContractorCell';

export const getColumns = ({
  isScheduleEditable,
  jobsiteId,
  openModal,
  user,
}: {
  isScheduleEditable: boolean;
  jobsiteId: string;
  openModal: (value: ScheduleWorkerModalValue) => void;
  user: AuthUser;
}): EditableShiftColumn[] =>
  ensureNonEmptyItems<EditableShiftColumn>([
    {
      id: EditableShiftColumnName.Contractor,
      Header: 'Contractor / Worker',
      Cell: ScheduleWorkersTableContractorCell,
      CellLoading: (): React.ReactElement => (
        <AvatarSkeleton size="xs" type="rounded" hideDetails />
      ),
      componentProps: (sw: ScheduleWorker): ScheduleWorker => sw,
    },
    {
      // TODO: [sc-13405] Stub up either count or specific scheduled worker here
      id: EditableShiftColumnName.Count,
      Header: 'Count',
      accessor: 'quantity',
      cellContainerClassName: 'md:odin-w-[10%]',
      disableSortBy: true,
    },
    {
      id: EditableShiftColumnName.Trade,
      Header: 'Trade',
      accessor: 'trade',
      cellContainerClassName: 'md:odin-w-[20%]',
      disableSortBy: true,
    },
    {
      id: EditableShiftColumnName.Activity,
      Header: 'Activity',
      accessor: 'activity',
      cellContainerClassName: 'md:odin-w-[20%]',
      disableSortBy: true,
    },
    {
      id: EditableShiftColumnName.Actions,
      Header: '',
      Cell: ScheduleWorkersTableActionsCell,
      CellLoading: (): React.ReactElement => (
        <DropdownButtonSkeleton cellAlignment="right" />
      ),
      componentProps: (
        scheduleWorker: ScheduleWorker,
      ): React.ComponentPropsWithoutRef<
        typeof ScheduleWorkersTableActionsCell
      >['componentProps'] => {
        return {
          editAction:
            isScheduleEditable &&
            user.isAllowed(to.editScheduleWorker, jobsiteId)
              ? (): void => openModal({ scheduleWorker, modalAction: 'edit' })
              : null,
          deleteAction:
            isScheduleEditable &&
            user.isAllowed(to.deleteScheduleWorker, jobsiteId)
              ? (): void => openModal({ scheduleWorker, modalAction: 'delete' })
              : null,
          viewNotesAction: scheduleWorker.notes
            ? (): void =>
                openModal({ scheduleWorker, modalAction: 'viewNotes' })
            : null,
        };
      },
      cellContainerClassName: 'md:odin-w-[20%]',
    },
  ]);
